window.addEventListener('load', (event) => {
    const star = "*"

    document.querySelectorAll('[type="password"]').forEach((input) => {
        let form = input.closest('form');
        let fakePass = form.querySelector('#fakePassword');
        changeStyle(input, fakePass);

        input.addEventListener('input', (e) => {
            changeStyle(e.target, fakePass);
        });
    });

    function changeStyle(input, fakePass) {
        let htmlStar = '';
        for (let i = 0; i < input.value.length; i++) {
            htmlStar += `${escape(star)}`;
        }
        fakePass.value = '';
        fakePass.value = htmlStar;
    }

});